
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 12.97a3.333 3.333 0 003.333-3.333V6.304a.667.667 0 10-1.333 0v3.333a2 2 0 11-4 0V6.304a.667.667 0 00-1.333 0v3.333A3.333 3.333 0 0010 12.97zm3.333 1.334H6.667a.667.667 0 000 1.333h6.666a.667.667 0 000-1.333z","fill":"#000C1F"}})])
          )
        }
      }
    